import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import sitemap from '@/Router/sitemap';
import { localizedRoute } from '@/utils/locale';

function Sitemap() {
	const { t } = useTranslation();
	return (
		<div className="mt-2 flex flex-row items-start justify-start gap-[20px]">
			<div className="flex flex-row gap-5">
				{sitemap.map(({ title, links }, index) => {
					return (
						<div
							className={`flex flex-col items-start justify-start gap-1 ${index ? 'w-[293px]' : 'w-[188px]'}`}
							key={`sitemap-${index}`}
						>
							<span className="mb-7 inline-flex text-sm font-semibold text-red">
								{t(title)}
							</span>
							{links.map((item, i) => {
								return (
									<Link
										className="justify-start text-left text-sm leading-7 text-white transition-colors hover:text-red"
										to={localizedRoute(item.to)}
										key={`sitemap-item-${i}`}
									>
										{t(item.text)}
									</Link>
								);
							})}
						</div>
					);
				})}
			</div>
		</div>
	);
}

export default Sitemap;
